import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import AuthLayout from './layouts/AuthLayout';
import AuthGuard from './guards/AuthGuard';
import SignIn from './pages/SignIn';
import Map2 from './pages/Map2';
import Products from './pages/Products';
import Pushpins from './pages/Pushpins';

export default function Router() {
  return useRoutes([
    {
      path: '/login',
      element: (
        <AuthLayout>
          <SignIn />
        </AuthLayout>
      )
    },
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { path: 'projects', element: <Products /> },
        { path: 'consequences', element: <Map2 /> },
        { path: 'pushpins', element: <Pushpins /> }
      ]
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/dashboard/projects" /> },
        { path: '/dashboard/app', element: <Navigate to="/dashboard/projects" /> }
      ]
    },
    { path: '*', element: <Navigate to="/dashboard/projects" replace /> }
  ]);
}

